import { Routes } from '@angular/router';
import { WizardShellComponent } from './ai/ai/wizard-shell.component';
import { NotAuthorizedComponent } from './core/components/not-authorized/not-authorized.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { SignInComponent } from './core/components/sign-in/sign-in.component';
import { authGuard } from './core/guard/auth.guard';
import { roleGuard } from './core/guard/role.guard';
import { ERoleType } from './core/models/model.model';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: WizardShellComponent,
        canActivate: [roleGuard],
        data: {
          role: ERoleType.AGENT,
        },
      },
    ],
  },
  {
    path: 'sign-in',
    component: SignInComponent,
  },
  {
    path: 'sign-up',
    component: SignInComponent,
    data: { signUp: true },
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent,
  },

  {
    path: '**',
    component: NotFoundComponent,
  },
];
